import { Trans } from '@/components'

import { BOOT_SOURCE_PAGE_SIZE } from './boot-source-pagination'

const SKELETON_ITEMS = Array.from({ length: BOOT_SOURCE_PAGE_SIZE }, (_, index) => index)
const SKELETON_PAGINATION_ITEMS = Array.from({ length: 5 }, (_, index) => index)

export function BootSourceSkeleton() {
  return (
    <div role="status" aria-live="polite">
      <div
        className="grid h-[244px] grid-cols-4 grid-rows-2 gap-4 overflow-hidden"
        aria-hidden="true"
      >
        {SKELETON_ITEMS.map((item) => (
          <div key={item} className="h-full rounded-lg border border-neutral-200 p-4">
            <div className="mb-3 flex items-center justify-between gap-2">
              <div className="h-4 w-24 rounded bg-neutral-100 motion-safe:animate-pulse" />
              <div className="h-4 w-14 rounded-full bg-neutral-100 motion-safe:animate-pulse" />
            </div>
            <div className="mb-2 h-5 w-40 max-w-full rounded bg-neutral-100 motion-safe:animate-pulse" />
            <div className="h-4 w-full rounded bg-neutral-100 motion-safe:animate-pulse" />
            <div className="mt-1 h-4 w-4/5 rounded bg-neutral-100 motion-safe:animate-pulse" />
          </div>
        ))}
      </div>

      <div className="mt-4 flex h-10 items-center justify-between gap-4" aria-hidden="true">
        <div className="h-5 w-48 rounded bg-neutral-100 motion-safe:animate-pulse" />
        <div className="flex shrink-0 gap-2">
          {SKELETON_PAGINATION_ITEMS.map((item) => (
            <div
              key={item}
              className="h-10 w-10 rounded-md bg-neutral-100 motion-safe:animate-pulse"
            />
          ))}
        </div>
      </div>

      <span className="sr-only">
        <Trans i18nKey="create.loadingBootSources">Loading boot sources</Trans>
      </span>
    </div>
  )
}
